import { getSendAttachmentLimitMessage } from '@/i18n/send-attachment-limit-copy';
import { readConvexErrorMessage } from '@/lib/error-utils';

/**
 * The server's message for a failed send, kept with its unsent row (#7719).
 * A `ConvexError` gives its own message rather than the transport wrapper.
 */
export function deliveryFailureReason(error: unknown): string | undefined {
  const convexMessage = readConvexErrorMessage(error);
  if (convexMessage) return convexMessage;
  return error instanceof Error && error.message ? error.message : undefined;
}

/** The first refused destination's message in a delivery receipt. */
export function receiptFailureReason(receipt: unknown): string | undefined {
  if (!receipt || typeof receipt !== 'object' || !('targets' in receipt))
    return undefined;
  const targets: unknown = receipt.targets;
  if (!Array.isArray(targets)) return undefined;
  for (const target of targets) {
    if (
      target &&
      typeof target === 'object' &&
      'accepted' in target &&
      target.accepted === false &&
      'error' in target &&
      typeof target.error === 'string' &&
      target.error
    )
      return target.error;
  }
  return undefined;
}

/**
 * Localized text for a refusal the server repeats on every retry, so the
 * unsent row says what to change instead of offering Retry. Null for
 * anything a retry can still fix.
 */
export function deliveryRefusalNotice(
  reason: string | undefined,
  locale: string | null | undefined
): string | null {
  if (!reason) return null;
  return getSendAttachmentLimitMessage(reason, locale);
}
